<div *ngFor="let item of mailList">
<!--  <app-platform-mail-card-viewer [item]="item"></app-platform-mail-card-viewer>-->
</div>
